function t(n) {
  return n == null;
}
function r(n) {
  return !t(n);
}
function e(n) {
  for (const i of n)
    if (r(i))
      return i;
}
export {
  e as firstNotNil,
  t as isNil,
  r as isNotNil
};
